import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import React, { useRef } from 'react';
import classNames from 'classnames';
import { useIsOverflowing, IconWrapper } from '@cognite/cogs-utils';
import '../../tokens/color-tokens/index.js';
import '../../tokens/elevation-tokens/index.js';
import { Body } from '../../tokens/typography/typography.js';
import { Tooltip } from '../tooltip/tooltip.js';

var OLD_TO_NEW_COLOR_SCHEME_MAP = {
  gray: 'onyx',
  red: 'ruby',
  orange: 'amber',
  yellow: 'canary',
  green: 'emerald',
  lightBlue: 'aquamarine',
  blue: 'sapphire',
  purple: 'amethyst',
  teal: 'turquoise'
};
/**
 * A tag chip is a compact representation of an object's key attribute or category.
 */
var TagChip = /*#__PURE__*/React.forwardRef(function (_a, outerRef) {
  var className = _a.className,
    icon = _a.icon,
    _a$colorScheme = _a.colorScheme,
    colorScheme = _a$colorScheme === undefined ? 'gray' : _a$colorScheme,
    _a$size = _a.size,
    size = _a$size === undefined ? 'small' : _a$size,
    _a$tooltip = _a.tooltip,
    tooltip = _a$tooltip === undefined ? true : _a$tooltip,
    tooltipProps = _a.tooltipProps,
    testId = _a['data-testid'],
    label = _a.label,
    otherProps = __rest(_a, ["className", "icon", "colorScheme", "size", "tooltip", "tooltipProps", 'data-testid', "label"]);
  var iconsSize = {
    'x-small': 12,
    small: 14,
    medium: 16
  };
  var ref = useRef(null);
  var isOverflowing = useIsOverflowing(ref, label);
  var showTooltip = tooltip === true && isOverflowing || typeof tooltip === 'string';
  return jsx(Tooltip, Object.assign({
    content: typeof tooltip === 'string' ? tooltip : label,
    disabled: !showTooltip
  }, tooltipProps, {
    children: jsxs("div", Object.assign({
      ref: outerRef,
      "data-testid": testId || label,
      className: classNames('cogs-v10', 'cogs-tagchip', "cogs-tagchip--" + size, "cogs-tagchip--" + OLD_TO_NEW_COLOR_SCHEME_MAP[colorScheme], className)
    }, otherProps, {
      children: [icon && jsx(IconWrapper, {
        size: iconsSize[size],
        className: "cogs-v10 cogs-tagchip--icon",
        children: icon
      }), label && jsx(Body, {
        size: size,
        ref: ref,
        strong: true,
        className: classNames('cogs-v10', 'cogs-tagchip--text'),
        children: label
      })]
    }))
  }));
});

export { OLD_TO_NEW_COLOR_SCHEME_MAP, TagChip };
